import "./TheVault.module.css";
import MainNavigation from "@/reusable_sections/Header";
import FullCollection from "./sections/FullCollection";
import HeritageFooter from "@/reusable_sections/Footer";
export default function TheVaultPage() {
  return <div>
      <MainNavigation />
      <FullCollection />
      <HeritageFooter />
    </div>;
}